export class LinkDto {
  onlineStoreURL: string;
  googlePlayStore: string;
  appleAppStore: string;
  id?: string;

  constructor(d?: LinkDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
